import type {
  LibraryFieldDef,
  LibraryFieldOption,
  LibraryFormSchema,
} from '@/features/metadata-library/types/metadataLibrary';
import { t } from '@lingui/core/macro';

export class LibraryFormRulesError extends Error {}

export function catalogSchema(
  fields: readonly LibraryFieldDef[],
  fieldKey: string,
): LibraryFormSchema {
  const schema = fields.find((field) => field.fieldKey === fieldKey)?.formSchema;
  if (!schema)
    throw new LibraryFormRulesError(t`The validation rules for ${fieldKey} could not be loaded.`);
  return schema;
}

export function catalogEnum(fields: readonly LibraryFieldDef[], fieldKey: string): string[] {
  const schema = catalogSchema(fields, fieldKey);
  if (!schema.enum)
    throw new LibraryFormRulesError(t`The options for ${fieldKey} could not be loaded.`);
  return schema.enum;
}

/** Returns the locale-specific labels for a standardized field's selectable values. */
export function catalogOptions(
  fields: readonly LibraryFieldDef[],
  fieldKey: string,
): readonly LibraryFieldOption[] {
  const options = fields.find((field) => field.fieldKey === fieldKey)?.options;
  if (!options)
    throw new LibraryFormRulesError(t`The options for ${fieldKey} could not be loaded.`);
  return options;
}

/** Keeps historical values readable when they are no longer available for selection. */
export function catalogOptionLabel(
  fields: readonly LibraryFieldDef[],
  fieldKey: string,
  value: string | null | undefined,
): string | null {
  if (!value) return null;
  return catalogOptions(fields, fieldKey).find((option) => option.value === value)?.label ?? value;
}
